import setListingAttributesDisclosureCategory from './utils/disclosureCategories/disclosureCategories';

export function enhanceListings(state = {}, reducerData) {
  const {type, ...payload} = reducerData || {};
  const {listings = {}, event = {}} = state || {};

  if (!listings.listingLoading && listings.data) {
    const {data = []} = listings;
    const {seatTraits = []} = reducerData || {};

    const enhancedListings = setListingAttributesDisclosureCategory(data, seatTraits);

    return {
      event: {...event, ...payload},
      listings: {...listings, data: enhancedListings},
    };
  }

  return {event: {...event, ...payload}};
}

export const closeImportantDisclaimer = (state) => {
  return {
    ...state,
    header: {
      ...state.header,
      forceShowDisclaimer: false,
    },
    event: {
      ...state.event,
      showDisclaimer: false,
    },
  };
};
